export default class GiftPackage {
    id: number;
    campaignCode: string;
    packageName: string;
    campaignId: number;
    packageCode: string;
    dataState: number=1;
}